import { APIResponse } from '@bighealth/api';

const aliasPipe = ({
  status_code = 500,
  result,
}: APIResponse): APIResponse => ({ status_code, result });

export { aliasPipe };
